import { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export const isRentBasedCategory = (
	category: GoalCategoryTypeEnum | undefined,
): boolean =>
	category === GoalCategoryTypeEnum.Pension ||
	category === GoalCategoryTypeEnum.Rent;
